import { SmartFeedEntityDynamicElementMixin } from "%/dynamic-component-editor/mixins/smart-feed-entity-dynamic-element-mixin";
// `~/stores/channel-store` lives outside the dynamic-component-editor
// directory tree (forbidden by the editor's isolation rule) and isn't
// available in Studio anyway. `getRealEntity` now mirrors
// `getExampleEntity` so edit-mode + production-preview both render
// off the same example data until a channel store is ported into the
// editor directory.
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import LayoutHeight from "%/dynamic-component-editor/options/layout-height";
import { mapState } from "pinia";
import { useGeneralStore } from "%/dynamic-component-editor/stores/general-store";

export const ChatRoomPageElementMixin = {
  extends: SmartFeedEntityDynamicElementMixin,
  options: [
    new LayoutHeight({ default: "fill" }, true),
    new LayoutWidth({ default: "fill" }, true),
  ],
  data() {
    return {
      LayoutWidth,
      LayoutHeight,
      description: "",
      channelHref: "",
      chatroomHeight: "fill",
      pageHeight: null,
    };
  },
  elementPanelSettings: {
    displayName: "Chat Room Widget",
    displayIcon: "list",
    elementGroup: "chatRoomElements",
    elementType: "element",
  },
  computed: {
    ...mapState(useGeneralStore, ["userId"]),
  },
  methods: {
    getExampleEntity() {
      return {
        "channel_id": 0,
        "channel_name": "general",
        "conversation_id": 0,
        "entity_id": 0,
        "context": "publication",
        "visibility": "public",
        "status": "active",
        "timestamp_created": 1739193729,
        "timestamp_updated": 1739193729,
      };
    },
    getRealEntity() {
      return this.getExampleEntity();
    },
  },
};
